import { MediaDevices } from 'enums';

export const QUERIES = {
  [MediaDevices.Desktop]: '(min-width: 1024px)',
  [MediaDevices.Tablet]: '(max-width: 1023px) and (min-width: 768px)',
  [MediaDevices.Mobile]: '(max-width: 767px)',
};
